import { render, staticRenderFns } from "./submissions.datagrid.vue?vue&type=template&id=4f07f9c2&scoped=true&"
import script from "./submissions.datagrid.vue?vue&type=script&lang=js&"
export * from "./submissions.datagrid.vue?vue&type=script&lang=js&"
import style0 from "./submissions.datagrid.vue?vue&type=style&index=0&id=4f07f9c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f07f9c2",
  null
  
)

export default component.exports